"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get CONTEXT_INFO_EXTRACT_COLUMN_ALIAS () {
        return CONTEXT_INFO_EXTRACT_COLUMN_ALIAS;
    },
    get CONTEXT_INFO_IS_CACHE_EXTRACT_COLUMN () {
        return CONTEXT_INFO_IS_CACHE_EXTRACT_COLUMN;
    },
    get EMIT_EVENT () {
        return EMIT_EVENT;
    },
    get MAX_CONCURRENT_TRANSFORMS () {
        return MAX_CONCURRENT_TRANSFORMS;
    },
    get MAX_NESTING_DEPTH () {
        return MAX_NESTING_DEPTH;
    },
    get META_COL_NAME () {
        return META_COL_NAME;
    },
    get NC_APP_SETTINGS () {
        return NC_APP_SETTINGS;
    },
    get NC_ATTACHMENT_FIELD_SIZE () {
        return NC_ATTACHMENT_FIELD_SIZE;
    },
    get NC_ATTACHMENT_URL_MAX_REDIRECT () {
        return NC_ATTACHMENT_URL_MAX_REDIRECT;
    },
    get NC_EMAIL_ASSETS_BASE_URL () {
        return NC_EMAIL_ASSETS_BASE_URL;
    },
    get NC_LICENSE_KEY () {
        return NC_LICENSE_KEY;
    },
    get NC_MAX_ATTACHMENTS_ALLOWED () {
        return NC_MAX_ATTACHMENTS_ALLOWED;
    },
    get NC_MAX_TEXT_LENGTH () {
        return NC_MAX_TEXT_LENGTH;
    },
    get NC_NON_ATTACHMENT_FIELD_SIZE () {
        return NC_NON_ATTACHMENT_FIELD_SIZE;
    },
    get NC_RECURSIVE_MAX_DEPTH () {
        return NC_RECURSIVE_MAX_DEPTH;
    },
    get NC_REFRESH_TOKEN_EXP_IN_DAYS () {
        return NC_REFRESH_TOKEN_EXP_IN_DAYS;
    },
    get QUERY_STRING_FIELD_ID_ON_RESULT () {
        return QUERY_STRING_FIELD_ID_ON_RESULT;
    },
    get QUERY_STRING_LINKS_AS_LTAR () {
        return QUERY_STRING_LINKS_AS_LTAR;
    },
    get S3_PATCH_KEYS () {
        return S3_PATCH_KEYS;
    },
    get V1_V2_DATA_PAYLOAD_LIMIT () {
        return V1_V2_DATA_PAYLOAD_LIMIT;
    },
    get V3_DATA_PAYLOAD_LIMIT () {
        return V3_DATA_PAYLOAD_LIMIT;
    },
    get V3_META_REQUEST_LIMIT () {
        return V3_META_REQUEST_LIMIT;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const NC_LICENSE_KEY = 'nc-license-key';
const NC_APP_SETTINGS = 'nc-app-settings';
const NC_NON_ATTACHMENT_FIELD_SIZE = +process.env['NC_NON_ATTACHMENT_FIELD_SIZE'] || 10 * 1024 * 1024; // 10 MB
const NC_ATTACHMENT_FIELD_SIZE = +process.env['NC_ATTACHMENT_FIELD_SIZE'] || 20 * 1024 * 1024; // 20 MB
const NC_MAX_ATTACHMENTS_ALLOWED = +process.env['NC_MAX_ATTACHMENTS_ALLOWED'] || 10;
const NC_REFRESH_TOKEN_EXP_IN_DAYS = parseInt(process.env.NC_REFRESH_TOKEN_EXP_IN_DAYS, 10) || 30;
// throw error if user provided invalid value
if (!NC_REFRESH_TOKEN_EXP_IN_DAYS || NC_REFRESH_TOKEN_EXP_IN_DAYS <= 0) {
    throw new Error('NC_REFRESH_TOKEN_EXP_IN_DAYS must be a positive number');
}
const NC_MAX_TEXT_LENGTH = +process.env['NC_MAX_TEXT_LENGTH'] || 100000;
const NC_EMAIL_ASSETS_BASE_URL = 'https://cdn.nocodb.com/emails/v2';
const NC_RECURSIVE_MAX_DEPTH = 7;
const QUERY_STRING_FIELD_ID_ON_RESULT = 'fieldIdOnResult';
const QUERY_STRING_LINKS_AS_LTAR = 'linksAsLtar';
const S3_PATCH_KEYS = [
    'uploads',
    'thumbnails',
    ...Object.values(_nocodbsdk.PublicAttachmentScope)
];
const V1_V2_DATA_PAYLOAD_LIMIT = +process.env['NC_DATA_PAYLOAD_LIMIT'] || 100;
const V3_DATA_PAYLOAD_LIMIT = +process.env['NC_DATA_PAYLOAD_LIMIT'] || 10;
const V3_META_REQUEST_LIMIT = 10;
const MAX_NESTING_DEPTH = 3;
const MAX_CONCURRENT_TRANSFORMS = 50;
const NC_ATTACHMENT_URL_MAX_REDIRECT = 3;
const EMIT_EVENT = {
    HANDLE_ATTACHMENT_URL_UPLOAD: '__nc_handleAttachmentUrlUpload'
};
const CONTEXT_INFO_EXTRACT_COLUMN_ALIAS = 'extractColumnAlias';
const CONTEXT_INFO_IS_CACHE_EXTRACT_COLUMN = 'isCacheExtractColumn';
const META_COL_NAME = 'nc_row_meta';
